import React, { useEffect, useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { create_product_benefit, attach_product_benefit } from "services/apiSrv";
import { useHistory, useParams } from "react-router-dom";
import { show_toast } from "utils/helpers";

import { useQuery } from "react-query";
import { api_srv } from "services";
import { fetch_benefit_categories } from "services/apiSrv";

export default function AddProductBenefit({ onSubmit, onHide, fetchBenefits = () => {} }) {
  const [benefits, setBenefits] = useState([
    { id: "001", name: "BNFT 001", type: "Optional" },
    { id: "002", name: "BNFT 002", type: "Embedded" },
  ]);

  const get_categories = async () => {
    try {
      let resp = await (await api_srv).fetch_benefit_categories();
      if (!resp) {
        throw new Error("Invalid response: categories not found");
      }
      console.log("===BENEFITS==", resp.data)
      return resp.data;
    } catch (err) {
      console.error("Error fetching categories:", err);
      throw err;
    }
  };

  const { data:categories, error, isLoading } = useQuery({
    queryKey: ["fetch_benefit_categories"],
    queryFn: get_categories,
  });

  const [loading, setLoading] = useState(false);
  const history = useHistory();
  const { id } = useParams();

  useEffect(() => {
    const initialize = async () => {
      try {
        // Example async fetch (replace with real API call)
        // let benefit_resp = await api_srv.list_benefits();
        // setBenefits(benefit_resp.benefits);
      } catch (err) {
        console.error("Error fetching benefits:", err);
      }
    };
    initialize();
  }, []);

  console.log("categories", categories)
  const validationSchema = Yup.object().shape({
    category: Yup.string().required("Category is required"),
    benefitType: Yup.string().required("Benefit Type is required"),
    reference: Yup.string().required("Reference is required"),
    // calculationType: Yup.string().required("Calculation Type is required"),
    calculationType: Yup.string()
    .when("benefitType", {
    is: "optional",
    then: Yup.string().required("Calculation Type is required"),
    otherwise: Yup.string().notRequired()
    }),
    value: Yup.string().when("calculationType", {
      is: (val) => val && ["percentageOfBase", "percentageOfValue", "percentageOfAccessories", "percentageOfLimit"].includes(val),
      then: Yup.string().required("Percentage value is required").matches(/^\d+(\.\d{1,2})?$/, "Must be a valid percentage (e.g., 10 or 10.5)"),
      otherwise: Yup.string().when("calculationType", {
        is: (val) => val === "flat" || val === "daily",
        then: Yup.string().required("Value is required"),
        otherwise: Yup.string().notRequired(),
      }),
    }),
    limitMin: Yup.number().when("calculationType", {
      is: (val) => ["percentageOfLimit"].includes(val),
      then: Yup.number().required("Minimum limit is required").positive("Must be positive"),
      otherwise: Yup.number().notRequired().positive("Must be positive"),
    }),
    limitMax: Yup.number().when("calculationType", {
      is: (val) => ["percentageOfLimit"].includes(val),
      then: Yup.number().required("Maximum limit is required").positive("Must be positive"),
      otherwise: Yup.number().notRequired().positive("Must be positive"),
    }),
    limitIsAdjustable: Yup.string().notRequired(),
    limitDefault: Yup.number().when("calculationType", {
      is: (val) => ["percentageOfLimit"].includes(val),
      then: Yup.number().required("Default limit is required").positive("Must be positive"),
      otherwise: Yup.number().notRequired().positive("Must be positive"),
    }),
    dailyMin: Yup.number().when("calculationType", {
      is: "daily",
      then: Yup.number().required("Daily minimum is required").positive("Must be positive"),
      otherwise: Yup.number().notRequired().positive("Must be positive"),
    }),
    dailyMax: Yup.number().when("calculationType", {
      is: "daily",
      then: Yup.number().required("Daily maximum is required").positive("Must be positive"),
      otherwise: Yup.number().notRequired().positive("Must be positive"),
    }),
    dailyIsAdjustable: Yup.string().when("calculationType", {
      is: "daily",
      then: Yup.string().required("Adjustable status is required"),
      otherwise: Yup.string().notRequired(),
    }),
    dailyDefault: Yup.number().when("calculationType", {
      is: "daily",
      then: Yup.number().required("Daily default is required").positive("Must be positive"),
      otherwise: Yup.number().notRequired().positive("Must be positive"),
    }),
    dailyDays: Yup.number().when("calculationType", {
      is: "daily",
      then: Yup.number().required("Number of days is required").positive("Must be positive"),
      otherwise: Yup.number().notRequired().positive("Must be positive"),
    }),
    claimCanClaim: Yup.string().notRequired(),
    claimConsumed: Yup.string().notRequired(),
    claimReinstatement: Yup.string().notRequired(),
  });

  const fieldOptions = {
    benefitType: [
      { value: "optional", label: "Optional" },
      { value: "embedded", label: "Embedded" },
    ],
    calculationType: [
      { value: "percentageOfBase", label: "Percentage of Base" },
      { value: "flat", label: "Flat" },
      { value: "daily", label: "Daily" },
      { value: "percentageOfValue", label: "Percentage of Value" },
      { value: "percentageOfAccessories", label: "Percentage of Accessories" },
      { value: "percentageOfLimit", label: "Percentage of Limit" },
    ],
    yesNo: [
      { value: "yes", label: "Yes" },
      { value: "no", label: "No" },
    ],
    reinstatement: [
      { value: "manual", label: "Manual" },
      { value: "auto", label: "Auto" },
    ],
  };

  const handleSubmit = async (values, { resetForm }) => {
    setLoading(true);
    console.log("Benefit added:", values);
    await attach_product_benefit(values, id);
    show_toast("Benefit added successfully", "success");
    fetchBenefits();
    onHide?.();
    if (onSubmit) onSubmit(values);
    setTimeout(() => {
      setLoading(false);
      resetForm();
    }, 1000);
  };

  const renderRadioGroup = (name, label, options) => (
    <div className="mb-2">
      <label className="form-label form-label-sm">{label}</label>
      <div className="d-flex flex-wrap" style={{ gap: "0.5rem" }}>
        {options.map((option) => (
          <div key={option.value} className="form-check">
            <Field
              type="radio"
              name={name}
              value={option.value}
              className="form-check-input"
              id={`${name}-${option.value}`}
            />
            <label className="form-check-label" htmlFor={`${name}-${option.value}`}>
              {option.label}
            </label>
          </div>
        ))}
      </div>
      <ErrorMessage name={name} component="div" className="text-danger small mt-1" />
    </div>
  );

  const renderRadioGroupGrid = (name, label, options, values) => {
    const columns = 2;
    const itemsPerColumn = Math.ceil(options.length / columns);
    const splitOptions = Array.from({ length: columns }, (_, colIndex) =>
      options.slice(colIndex * itemsPerColumn, (colIndex + 1) * itemsPerColumn)
    );

    return (
      <div className="mb-2">
        <label className="form-label form-label-sm">{label}</label>
        <div className="row g-2">
          {splitOptions.map((columnOptions, colIndex) => (
            <div key={colIndex} className="col">
              {columnOptions.map((option) => (
                <React.Fragment key={option.value}>
                  <div className="form-check">
                    <Field
                      type="radio"
                      name={name}
                      value={option.value}
                      className="form-check-input"
                      id={`${name}-${option.value}`}
                    />
                    <label className="form-check-label" htmlFor={`${name}-${option.value}`}>
                      {option.label}
                    </label>
                  </div>
                  {values.calculationType === option.value && (
                    <div className="mt-2 mb-2 ms-4">
                      <label className="form-label form-label-sm">
                        Value {option.value.includes("percentage") ? "(%)" : ""}
                      </label>
                      <Field
                        name="value"
                        type="number"
                        className="form-control form-control-sm"
                        placeholder={option.value.includes("percentage") ? "Enter percentage (e.g., 10)" : "Enter value"}
                      />
                      <ErrorMessage name="value" component="div" className="text-danger small mt-1" />
                    </div>
                  )}
                </React.Fragment>
              ))}
            </div>
          ))}
        </div>
        <ErrorMessage name={name} component="div" className="text-danger small mt-1" />
      </div>
    );
  };

  const renderCheckbox = (name, label) => (
    <div className="mb-2">
      <div className="form-check">
        <Field
          type="checkbox"
          name={name}
          value="yes"
          className="form-check-input"
          id={name}
        />
        <label className="form-check-label" htmlFor={name}>{label}</label>
      </div>
      <ErrorMessage name={name} component="div" className="text-danger small mt-1" />
    </div>
  );

  return (
    <div className="p-4 bg-white rounded-lg shadow-md">
      <Formik
        initialValues={{
          category: "",
          benefitType: "",
          reference: "",
          calculationType: "",
          value: "",
          limitMin: "",
          limitMax: "",
          limitIsAdjustable: "no",
          limitDefault: "",
          dailyMin: "",
          dailyMax: "",
          dailyIsAdjustable: "no",
          dailyDefault: "",
          dailyDays: "",
          claimCanClaim: "",
          claimConsumed: "",
          claimReinstatement: "",
        }}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {({ values }) => (
          <Form className="needs-validation" noValidate>
            <style>
              {`
                .form-label-sm {
                  font-size: 0.875rem;
                  margin-bottom: 0.25rem;
                }
                .text-danger {
                  font-size: 0.75rem;
                }
              `}
            </style>
            {/* General Information */}
            <div className="mb-3 pb-3 border-bottom">
              <h5 className="mb-2">General Information</h5>
              <div className="row g-2">
                <div className="col-md-4">
                  <label htmlFor="category" className="form-label form-label-sm">Category</label>
                  <Field
                    as="select"
                    name="category"
                    className="form-control form-control-sm"
                  >
                    <option value="">Select a category</option>
                    {categories &&
                      categories?.map((cat) => (
                        <option key={cat?._id} value={cat?.benefit_category_ref}>
                          {cat?.benefit_category_name}
                        </option>
                      ))}
                  </Field>
                  <ErrorMessage name="category" component="div" className="text-danger small mt-1" />
                </div>
                <div className="col-md-4">
                  {renderRadioGroup("benefitType", "Benefit Type", fieldOptions.benefitType)}
                </div>
                <div className="col-md-4">
                  <label htmlFor="reference" className="form-label form-label-sm">Reference</label>
                  <Field
                    name="reference"
                    type="text"
                    className="form-control form-control-sm"
                    placeholder="Enter reference"
                  />
                  <ErrorMessage name="reference" component="div" className="text-danger small mt-1" />
                </div>
              </div>
            </div>

            {/* Calculation */}
            {/* <div className="mb-3 pb-3 border-bottom">
              <h5 className="mb-2">Calculation</h5>
              {renderRadioGroupGrid("calculationType", "Calculation Type", fieldOptions.calculationType, values)}
            </div> */}

                        {/* Calculation - Only show if benefitType is 'optional' */}
            {values.benefitType === "optional" && (
              <div className="mb-3 pb-3 border-bottom">
                <h5 className="mb-2">Calculation</h5>
                {renderRadioGroupGrid("calculationType", "Calculation Type", fieldOptions.calculationType, values)}
              </div>
            )}

            {/* Limit, Daily, Claim Sections - Only show if benefitType is 'embedded' */}
            {values.benefitType === "embedded" && (
              <div className="row g-2 mb-3 pb-3 border-bottom">
                {/* Limit Section */}
                {(
                  <div className="col-md-4">
                    <h6 className="mb-2">Limit</h6>
                    <div className="mb-2">
                      <label htmlFor="limitMin" className="form-label form-label-sm">Minimum</label>
                      <Field
                        name="limitMin"
                        type="number"
                        className="form-control form-control-sm"
                        placeholder="Enter minimum"
                      />
                      <ErrorMessage name="limitMin" component="div" className="text-danger small mt-1" />
                    </div>
                    <div className="mb-2">
                      <label htmlFor="limitMax" className="form-label form-label-sm">Maximum</label>
                      <Field
                        name="limitMax"
                        type="number"
                        className="form-control form-control-sm"
                        placeholder="Enter maximum"
                      />
                      <ErrorMessage name="limitMax" component="div" className="text-danger small mt-1" />
                    </div>
                    {renderCheckbox("limitIsAdjustable", "Is Adjustable")}
                    {/* <div className="mb-2">
                      <label htmlFor="limitDefault" className="form-label form-label-sm">Default</label>
                      <Field
                        name="limitDefault"
                        type="number"
                        className="form-control form-control-sm"
                        placeholder="Enter default"
                      />
                      <ErrorMessage name="limitDefault" component="div" className="text-danger small mt-1" />
                    </div> */}
                  </div>
                )}

                {/* Daily Section */}
                {values.calculationType === "daily" && (
                  <div className="col-md-4">
                    <h6 className="mb-2">Daily</h6>
                    <div className="mb-2">
                      <label htmlFor="dailyMin" className="form-label form-label-sm">Minimum</label>
                      <Field
                        name="dailyMin"
                        type="number"
                        className="form-control form-control-sm"
                        placeholder="Enter minimum"
                      />
                      <ErrorMessage name="dailyMin" component="div" className="text-danger small mt-1" />
                    </div>
                    <div className="mb-2">
                      <label htmlFor="dailyMax" className="form-label form-label-sm">Maximum</label>
                      <Field
                        name="dailyMax"
                        type="number"
                        className="form-control form-control-sm"
                        placeholder="Enter maximum"
                      />
                      <ErrorMessage name="dailyMax" component="div" className="text-danger small mt-1" />
                    </div>
                    {renderCheckbox("dailyIsAdjustable", "Is Adjustable")}
                    <div className="mb-2">
                      <label htmlFor="dailyDefault" className="form-label form-label-sm">Default</label>
                      <Field
                        name="dailyDefault"
                        type="number"
                        className="form-control form-control-sm"
                        placeholder="Enter default"
                      />
                      <ErrorMessage name="dailyDefault" component="div" className="text-danger small mt-1" />
                    </div>
                    <div className="mb-2">
                      <label htmlFor="dailyDays" className="form-label form-label-sm">Days</label>
                      <Field
                        name="dailyDays"
                        type="number"
                        className="form-control form-control-sm"
                        placeholder="Enter days"
                      />
                      <ErrorMessage name="dailyDays" component="div" className="text-danger small mt-1" />
                    </div>
                  </div>
                )}
               

  
              </div>
            )}

            {/* Limit, Daily, Claim Sections */}
            <div className="row g-2">
              {/* Limit Section */}
              {["percentageOfLimit"].includes(values.calculationType) && values.benefitType === "optional" && (
                <div className="col-md-4">
                  <h6 className="mb-2">Limit</h6>
                  <div className="mb-2">
                    <label htmlFor="limitMin" className="form-label form-label-sm">Minimum</label>
                    <Field
                      name="limitMin"
                      type="number"
                      className="form-control form-control-sm"
                      placeholder="Enter minimum"
                    />
                    <ErrorMessage name="limitMin" component="div" className="text-danger small mt-1" />
                  </div>
                  <div className="mb-2">
                    <label htmlFor="limitMax" className="form-label form-label-sm">Maximum</label>
                    <Field
                      name="limitMax"
                      type="number"
                      className="form-control form-control-sm"
                      placeholder="Enter maximum"
                    />
                    <ErrorMessage name="limitMax" component="div" className="text-danger small mt-1" />
                  </div>
                  {renderCheckbox("limitIsAdjustable", "Is Adjustable")}
                  <div className="mb-2">
                    <label htmlFor="limitDefault" className="form-label form-label-sm">Default</label>
                    <Field
                      name="limitDefault"
                      type="number"
                      className="form-control form-control-sm"
                      placeholder="Enter default"
                    />
                    <ErrorMessage name="limitDefault" component="div" className="text-danger small mt-1" />
                  </div>
                </div>
              )}

              {/* Daily Section */}
              {values.calculationType === "daily" && (
                <div className="col-md-4">
                  <h6 className="mb-2">Daily</h6>
                  <div className="mb-2">
                    <label htmlFor="dailyMin" className="form-label form-label-sm">Minimum</label>
                    <Field
                      name="dailyMin"
                      type="number"
                      className="form-control form-control-sm"
                      placeholder="Enter minimum"
                    />
                    <ErrorMessage name="dailyMin" component="div" className="text-danger small mt-1" />
                  </div>
                  <div className="mb-2">
                    <label htmlFor="dailyMax" className="form-label form-label-sm">Maximum</label>
                    <Field
                      name="dailyMax"
                      type="number"
                      className="form-control form-control-sm"
                      placeholder="Enter maximum"
                    />
                    <ErrorMessage name="dailyMax" component="div" className="text-danger small mt-1" />
                  </div>
                  {renderCheckbox("dailyIsAdjustable", "Is Adjustable")}
                  <div className="mb-2">
                    <label htmlFor="dailyDefault" className="form-label form-label-sm">Default</label>
                    <Field
                      name="dailyDefault"
                      type="number"
                      className="form-control form-control-sm"
                      placeholder="Enter default"
                    />
                    <ErrorMessage name="dailyDefault" component="div" className="text-danger small mt-1" />
                  </div>
                  <div className="mb-2">
                    <label htmlFor="dailyDays" className="form-label form-label-sm">Days</label>
                    <Field
                      name="dailyDays"
                      type="number"
                      className="form-control form-control-sm"
                      placeholder="Enter days"
                    />
                    <ErrorMessage name="dailyDays" component="div" className="text-danger small mt-1" />
                  </div>
                </div>
              )}

              {/* Claim Section */}
              <div className="col-md-4">
                <h6 className="mb-2">Claim</h6>
                {renderRadioGroup("claimCanClaim", "Can Claim", fieldOptions.yesNo)}
                {renderRadioGroup("claimConsumed", "Consumed on Claim", fieldOptions.yesNo)}
                {renderRadioGroup("claimReinstatement", "Reinstatement", fieldOptions.reinstatement)}
              </div>
            </div>

            {/* Submit Button */}
            <div className="d-flex justify-content-end mt-3">
              <button
                type="submit"
                className={`btn btn-primary btn-md d-flex align-items-center ${loading ? "disabled" : ""}`}
                disabled={loading}
              >
                {loading ? (
                  <>
                    <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true" />
                    Saving...
                  </>
                ) : (
                  "Save"
                )}
              </button>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
}